import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
// 名字改了  类名改了  后面的BaseId 和Id也根据Rdo来改
@Pipe({
  name: 'dateRangePipe'
})
export class GDateRangePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    let start, end;
    if (value) {
      let valueArr = value.split(',');
      if (valueArr && valueArr[0]) {
        var timestamp = Date.parse(valueArr[0]);
        start = moment(timestamp).format();
      }
      if (valueArr && valueArr[1]) {
        var timestamp = Date.parse(valueArr[1]);
        end = moment(timestamp).format();
      }

      return [start, end];
    }
  }
}
